module.exports = __webpack_public_path__ + "static/img/medium_logo2.8844b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/medium_logo2.png
// module id = FIid
// module chunks = 11